import { InjectionToken, inject } from '@angular/core';
import { IChatStore } from './chat.public';
import { ChatStore } from './chat.store';

export const CHAT_STORE = new InjectionToken<IChatStore>('CHAT_STORE', {
    providedIn: 'root',
    factory: () => inject(ChatStore) as IChatStore,
});
